<div>
    <img class="welcomeImage" src="/Images/UnifocusLogo_Blue.png">
</div>

